import { render, staticRenderFns } from "./TeachingWorkPreviewModal.vue?vue&type=template&id=10c45101&scoped=true"
import script from "./TeachingWorkPreviewModal.vue?vue&type=script&lang=js"
export * from "./TeachingWorkPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./TeachingWorkPreviewModal.vue?vue&type=style&index=0&id=10c45101&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c45101",
  null
  
)

export default component.exports